<template>
  <div class="flex flex-col gap-2">
    <h1 class="text-xl font-bold capitalize-first">{{ $t('global.items') }}</h1>
    <table class="table-fixed">
      <thead>
        <tr class="bg-gray-100 dark:bg-slate-700">
          <th class="w-12 px-3 py-2 text-center uppercase">
            {{ $t('global.quantity_short') }}
          </th>
          <th class="w-full px-3 py-2 text-left uppercase">
            {{ $t('attributes.products') }}
          </th>
          <th class="w-24 px-3 py-2 text-center uppercase">
            {{ $t('global.vat') }}
          </th>
          <th class="w-28 px-3 py-2 text-center uppercase">
            {{ $t('global.unit_price') }}
          </th>
          <th v-if="has_reduction" class="w-24 px-3 py-2 text-center uppercase">
            {{ $t('attributes.reduction') }}
          </th>
          <th class="w-28 px-3 py-2 text-center uppercase">
            {{ $t('global.total') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in invoice_items" :key="item.id" class="group">
          <td class="px-3 py-2 text-center align-top">
            <div class="font-medium">{{ item.quantity }}</div>
          </td>
          <td
            class="flex flex-col gap-1 px-3 py-2 align-top text-gray-900 dark:text-gray-100"
          >
            <div class="flex font-bold">
              <button
                v-if="editable"
                type="button"
                class="text-left hover:text-primary-600"
                @click="$emit('event-click', item.id)"
              >
                {{ item.name }}
              </button>
              <span v-else>{{ item.name }}</span>
            </div>
            <div
              v-if="item.description && item.description !== item.name"
              class="text-xs whitespace-pre-line"
            >
              {{ item.description }}
            </div>
            <div
              v-if="item.remarks"
              class="text-xs whitespace-pre-line text-gray-400"
            >
              {{ $t('attributes.remarks') }}: {{ item.remarks }}
            </div>
          </td>
          <td class="px-3 py-2 text-center align-top">
            <div class="font-medium">
              {{ String(item.vat_rate).replace('.', ',') }}%
            </div>
          </td>
          <td class="px-3 py-2 text-right align-top">
            <div class="font-medium">
              {{ $h.formatCurrency(item.final_price_excluding_vat) }}
            </div>
            <span class="text-xs leading-3">
              {{ $h.formatCurrency(item.final_price_including_vat) }}
            </span>
          </td>
          <td v-if="has_reduction" class="px-3 py-2 text-center align-top">
            <span v-if="item.reduction > 0">{{ item.reduction }} %</span>
          </td>
          <td class="px-3 py-2 text-right align-top">
            <div class="font-medium">
              {{ $h.formatCurrency(item.final_price_total_excluding_vat) }}
            </div>
            <span class="text-xs leading-3">
              {{ $h.formatCurrency(item.final_price_total_including_vat) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * Invoice lines, styled as Funeral Manager's InvoicingItemsTable (detailed
 * mode): price excluding VAT in bold, including VAT below. Crema items have
 * no categories, so there is a single group.
 */
export default {
  name: 'InvoicingItemsTable',
  props: {
    invoice_items: {
      type: Array,
      required: true
    },
    invoiceIsNotEstablished: {
      type: Boolean,
      required: false
    }
  },
  emits: ['event-click'],
  computed: {
    ...mapGetters({ auth: 'auth/getAuth' }),
    has_reduction() {
      return this.invoice_items?.some((item) => item.reduction > 0)
    },
    auth_role() {
      return this.auth.roles[0]
    },
    editable() {
      return this.invoiceIsNotEstablished && this.auth_role !== 'customer-user'
    }
  }
}
</script>
